// extracted by mini-css-extract-plugin
module.exports = {"label":"ContactsFilter_label__2JSBf","input":"ContactsFilter_input__2VoAP"};